import { useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $getRoot,
  $getSelection,
  $isParagraphNode,
  $isRangeSelection,
  COMMAND_PRIORITY_HIGH,
  INSERT_LINE_BREAK_COMMAND,
  INSERT_PARAGRAPH_COMMAND,
  KEY_ENTER_COMMAND,
  PASTE_COMMAND,
} from 'lexical';

export default function SingleLinePlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const unregisterEnter = editor.registerCommand(
      KEY_ENTER_COMMAND,
      () => true,
      COMMAND_PRIORITY_HIGH,
    );

    const unregisterLineBreak = editor.registerCommand(
      INSERT_LINE_BREAK_COMMAND,
      () => true,
      COMMAND_PRIORITY_HIGH,
    );

    const unregisterParagraph = editor.registerCommand(
      INSERT_PARAGRAPH_COMMAND,
      () => true,
      COMMAND_PRIORITY_HIGH,
    );

    const unregisterPaste = editor.registerCommand(
      PASTE_COMMAND,
      (event: ClipboardEvent) => {
        if (!event.clipboardData) {
          return false;
        }
        const text = event.clipboardData.getData('text/plain');
        if (text == null) {
          return false;
        }
        const sanitized = text.replace(/\s*\n+\s*/g, ' ');
        event.preventDefault();
        editor.update(() => {
          const selection = $getSelection();
          if ($isRangeSelection(selection)) {
            selection.insertText(sanitized);
          }
        });
        return true;
      },
      COMMAND_PRIORITY_HIGH,
    );

    const unregisterUpdateListener = editor.registerUpdateListener(() => {
      editor.update(() => {
        const paragraphs = $getRoot().getChildren().filter($isParagraphNode);

        if (paragraphs.length <= 1) {
          return;
        }

        const [firstParagraph, ...otherParagraphs] = paragraphs;
        const allChildren = paragraphs.flatMap(p => p.getChildren());

        firstParagraph.clear();
        firstParagraph.append(...allChildren);
        otherParagraphs.forEach(p => p.remove());
      });
    });

    return () => {
      unregisterEnter();
      unregisterLineBreak();
      unregisterParagraph();
      unregisterPaste();
      unregisterUpdateListener();
    };
  }, [editor]);

  return null;
}
